
(() => {
  "use strict";

  const SHIPPING_GOAL = 350000; // Rs. 3,500 in paisa
  const QUANTITY_GOAL = 3;

  const root = window.Shopify?.routes?.root || "/";
  const cartUrl = root.replace(/\/?$/, "/") + "cart.js";

  const RED = "#d00000";
  const GREEN = "#16a34a";

  let updating = false;
  let rerunRequested = false;

  function money(cents) {
    return "Rs." + (cents / 100).toLocaleString("en-PK", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function setProgress(bar, percentage, unlocked) {
    if (!bar) return;

    const progress = Math.max(0, Math.min(percentage, 100));

    bar.style.width = progress + "%";

    bar.classList.toggle("is-complete", unlocked);

    const color = unlocked ? GREEN : RED;

    bar.style.setProperty(
      "background-color",
      color,
      "important"
    );

    bar.style.setProperty(
      "background",
      color,
      "important"
    );

    bar.dataset.rewardComplete = unlocked ? "true" : "false";
  }

  function renderRewards(el, cart) {
    const total = cart.total_price;
    const count = cart.item_count;

    // Free Shipping: Rs.3500 OR 3 items
    const shippingUnlocked =
      total >= SHIPPING_GOAL || count >= QUANTITY_GOAL;

    // Bundle: 3 items
    const bundleUnlocked = count >= QUANTITY_GOAL;

    const remaining = Math.max(SHIPPING_GOAL - total, 0);

    // Shipping must reach 100% whenever unlocked.
    const shippingProgress = shippingUnlocked
      ? 100
      : Math.min((total / SHIPPING_GOAL) * 100, 100);

    const bundleProgress = Math.min(
      (count / QUANTITY_GOAL) * 100,
      100
    );

    const shippingMessage = el.querySelector(
      "[data-reward-shipping-message]"
    );

    const bundleMessage = el.querySelector(
      "[data-reward-bundle-message]"
    );

    const shippingBar = el.querySelector(
      "[data-reward-shipping-bar]"
    );

    const bundleBar = el.querySelector(
      "[data-reward-bundle-bar]"
    );

    const amountLabel = el.querySelector(
      "[data-reward-amount]"
    );

    const countLabel = el.querySelector(
      "[data-reward-count]"
    );

    if (shippingMessage) {
      shippingMessage.textContent = shippingUnlocked
        ? "🎉 You've unlocked Free Shipping!"
        : `Add ${money(remaining)} more to unlock Free Shipping`;
    }

    if (bundleMessage) {
      bundleMessage.textContent = bundleUnlocked
        ? "🎉 5% OFF + Free Shipping Unlocked!"
        : `Add ${Math.max(QUANTITY_GOAL - count, 0)} more item(s) to unlock both rewards`;
    }

    // Update each bar independently.
    setProgress(
      shippingBar,
      shippingProgress,
      shippingUnlocked
    );

    setProgress(
      bundleBar,
      bundleProgress,
      bundleUnlocked
    );

    if (amountLabel) {
      amountLabel.textContent = money(total);
    }

    if (countLabel) {
      countLabel.textContent =
        `${count} / ${QUANTITY_GOAL} items`;
    }
  }

  async function updateRewards() {
    if (updating) {
      rerunRequested = true;
      return;
    }

    if (!document.querySelector("[data-custom-cart-rewards]")) {
      return;
    }

    updating = true;

    try {
      const response = await fetch(cartUrl, {
        cache: "no-store",
        credentials: "same-origin"
      });

      if (!response.ok) {
        throw new Error("Cart request failed");
      }

      const cart = await response.json();

      document.querySelectorAll(
        "[data-custom-cart-rewards]"
      ).forEach(el => {
        // Always apply colors, even if values have not changed.
        renderRewards(el, cart);
      });

    } catch (error) {
      console.warn("Cart rewards update failed:", error);
    } finally {
      updating = false;

      if (rerunRequested) {
        rerunRequested = false;
        updateRewards();
      }
    }
  }

  // Initial render
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      updateRewards
    );
  } else {
    updateRewards();
  }

  // Handle cart drawer quantity and remove actions
  document.addEventListener("click", event => {
    if (event.target.closest(
      "#MinimogCartDrawer, .m-cart__form, .m-cart-form"
    )) {
      setTimeout(updateRewards, 400);
      setTimeout(updateRewards, 1000);
    }
  });

  // Synchronize AJAX cart changes
  setInterval(() => {
    if (
      document.visibilityState === "visible" &&
      document.querySelector("[data-custom-cart-rewards]")
    ) {
      updateRewards();
    }
  }, 2000);

  // Make available to theme scripts
  window.updateCustomCartRewards = updateRewards;
})();
